export const htmlStringNormalizer = (input: string) => {
  return input?.replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec)).replace(/\\r|\\n|\\t/g, '');
};
